import React from "react";
import { FRAMES } from "../constants/frames";

// Màn chọn khung ảnh.
export default function FramePicker({ onSelect }) {
    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "clamp(12px, 3vw, 24px)",
                width: "100%"
            }}
        >
            {FRAMES.map(frame => (
                <img
                    key={frame.id}
                    src={frame.src}
                    alt="khung ảnh"
                    onClick={() => onSelect(frame)}
                    onMouseEnter={e => {
                        e.currentTarget.style.transform = "scale(1.08)";
                        e.currentTarget.style.boxShadow =
                            "0 12px 30px rgba(255,122,162,0.45)";
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = frameThumb.boxShadow;
                    }}
                    style={frameThumb}
                />
            ))}
        </div>
    );
}

const frameThumb = {
    // Co giãn: 2 cột gọn trên điện thoại, tối đa 180px trên máy tính.
    width: "clamp(130px, 42vw, 180px)",
    cursor: "pointer",
    borderRadius: 12,
    boxShadow: "0 8px 8px rgba(0,0,0,0.15)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease"
};
